module.exports = __webpack_public_path__ + "img/2.778cea88.png";